export default __webpack_public_path__ + "static/media/checkedTick.ac7bc806.svg";